let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8Z3BN")).then(() => parcelRequire('13oZu'));